class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', function (evt) {
      if (evt.code === 'Escape') this.close();
    }.bind(this));
    this.querySelectorAll('.cart-notification__close, [data-ps-cart-notification-continue]').forEach(function (closeButton) {
      closeButton.addEventListener('click', this.close.bind(this));
    }.bind(this));
  }

  open() {
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    this.notification.style.top = scrollTop + 'px';
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      function () {
        this.notification.focus();
        trapFocus(this.notification);
      }.bind(this),
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    this.notification.style.removeProperty('top');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach(function (section) {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    }.bind(this));

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: '[id="cart-notification-product-' + this.cartItemKey + '"]',
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    var target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      var disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
